import React from 'react';
//import { useStaticQuery, graphql } from "gatsby"

const GitHubImages = ({ whichDirectory, whichImage, title, alt, align, width, height, className  }) => {

//   const data = useStaticQuery(graphql`
//     {

//     }
//   `)

  return (

	<picture>
		<source
		srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/${whichDirectory}/${whichImage}.webp`}
		type="image/webp"
		/>
		<img
		src={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/${whichDirectory}/${whichImage}.png`}
		align="left"
		alt={alt}
		title={title}
		align={align}
		width={width}
		height={height}
		className={className}
		/>
	</picture>

  );

}
export default GitHubImages
